import { gql } from 'graphql-tag';
import appsyncclient from '../../api/AppSync';
import projectTable from "../mock/project"
import actions from "../constant";
import { getStudies } from '../../graphql/porject';

const initialState = {
  tableData: [],
  tableLoading: false
};

export const ProjectReducer = (state=initialState, action) => {
  switch ( action.type ) {
    case actions.GET_PROJECT_STATE:
      state.tableData = action.payload;
      state.tableLoading = false;
      return { ...state }
  
    default:
      return state
  }
};

export const getProjectTableData = (params, callBack) => async (dispatch, getState, a,b) => {
  initialState.tableLoading = true;
  try {
    const result = await appsyncclient.query({
      query: gql(getStudies),
      variables: params,
      fetchPolicy: 'no-cache',
    });
    if(result?.data?.getStudies) {
      dispatch({ type: actions.GET_PROJECT_STATE, payload: result.data.getStudies})
    }
  } catch(error) {
    dispatch({ type: actions.GET_PROJECT_STATE, payload: projectTable})
  }
};